import { useEffect, useRef, useState } from 'react';

const tabs = [
  { key: 'djing', label: '디제잉', weeks: 5, price: '4주차당 28만원/ 30만원 /35만원' },
  { key: 'beatmaking', label: '미디작곡', weeks: 8, price: '4주차당 28만원/ 30만원 /35만원' },
  { key: 'lyrics', label: '랩메이킹', weeks: 4, price: '4주차당 28만원/ 30만원 /35만원' },
  { key: 'producing', label: '프로듀싱', weeks: 8, price: '4주차당 35만원/ 37만원 /40만원' },
  { key: 'mixing', label: '믹싱/마스터링', weeks: 4, price: '4주차당 28만원/ 30만원 /35만원' },
];

const curriculumData: Record<string, { title: string; subtitle: string; weeks: { week: number; items: string[] }[] }> = {
  lyrics: {
    title: '랩 메이킹 커리큘럼',
    subtitle: '라임과 플로우의 기초부터 훅 메이킹까지',
    weeks: [
      {
        week: 1,
        items: [
          '리듬을 구성하는 요소 — 라임, 플로우 이해',
          '마디 진행의 의미 (Verse 구성과 마디 개념)',
          '기본 리듬의 이해 — 2/4, 4/4 리듬',
          '4마디 리듬 변환 포인트 파악',
        ],
      },
      {
        week: 2,
        items: [
          '1주차 과제 및 벌스 피드백',
          '가사 작법 수정, 리듬 개선, 톤/발성/강세 개선',
          '벌스의 시작 — 첫 단추 꿰매기 (앞, 정, 뒤)',
          'FLOW FREESTYLE — 자유로운 리듬 전개 작법',
          '음절 라임 반복 진행',
        ],
      },
      {
        week: 3,
        items: [
          '2주차 과제 및 벌스 피드백',
          '훅 메이킹 (붐뱁, 트랩, EDM 등)',
          '멜로디 라인 — 리듬 그리기를 이용한 멜로디 형성',
          '에이블톤을 활용한 오토튠 사용',
        ],
      },
      {
        week: 4,
        items: [
          '3주차 과제 및 벌스 피드백',
          '엇박의 이해 — 반대 개념과 예시 적용',
          '종합 정리 및 다음 회차 계획 수립',
          '이론 심화, 레코딩, 음향, 비트메이킹, 프로듀싱 방향 제시',
        ],
      },
      {
        week: 5,
        items: [
          '레코딩과 함께 진행하는 이론 심화',
          '레코딩 기초 — 녹음물을 통한 문제점 파악',
          '음향 기초 — 플러그인 사용법 토대로 진행',
          '프로듀싱 기초 — 트랙 관리와 음원 완성 방법',
        ],
      },
    ],
  },
  physical: {
    title: '피지컬 커버 커리큘럼',
    subtitle: '보컬, 랩의 피지컬과 음향, 음악 기초 클래스 (4주 / 25만원)',
    weeks: [
      {
        week: 1,
        items: [
          '가장 아끼는 노래 레코딩',
          '보컬 디렉팅과 모니터링',
          '내가 부족한 점 알아가기',
        ],
      },
      {
        week: 2,
        items: [
          '가장 잘 부르는 노래 레코딩',
          '보컬 디렉팅과 모니터링',
          '원곡과 비교하며 부족한 점 알아가기',
        ],
      },
      {
        week: 3,
        items: [
          '레코딩된 음원 수정하기',
          '디테일하게 잡아가며 수정',
          '레코딩 스킬, 믹싱에 기초 지식 습득',
        ],
      },
      {
        week: 4,
        items: [
          '레코딩된 음원을 완성하기',
          '완성된 음원을 음원 시장과 유튜브 시장에 비교',
          '구체적인 목표 설정',
        ],
      },
    ],
  },
  producing: {
    title: '프로듀싱 커리큘럼',
    subtitle: '보컬의 Mixtape, DEMO, 음원 발매 (8주 / 4주당 30만원)',
    weeks: [
      {
        week: 1,
        items: [
          '가장 아끼는 노래 들어보고 알아보기',
          '노래 진행 3분간의 구조와 악기의 구분',
          '멜로디라인의 이해',
        ],
      },
      {
        week: 2,
        items: [
          '가장 아끼는 노래 녹음하고 분석하기',
          '숨어있는 디테일적인 포인트들을 찾아내기',
        ],
      },
      {
        week: 3,
        items: [
          '멜로디 라인 짜보기',
          'MR에 내 멜로디 라인을 짜보기',
        ],
      },
      {
        week: 4,
        items: [
          '가사 써보기',
          '가사 쓰는 법과 기본적인 박자개념 확립',
        ],
      },
      {
        week: 5,
        items: [
          '내 노래 레코딩 해보기',
          '보컬 디렉팅과 노래 보완',
        ],
      },
      {
        week: 6,
        items: [
          '내 노래와 아끼는 노래 비교해보기',
          '디테일적인 요소를 찾아냄과 노래의 풍성함 채우기',
        ],
      },
      {
        week: 7,
        items: [
          '레코딩된 음원 수정하기',
          '레코딩 수정과 추가, 제거 후 믹싱 과정 모니터링',
        ],
      },
      {
        week: 8,
        items: [
          '내 노래 완성하기',
          '마스터링 과정 모니터링과 발매된 음원들과의 비교분석',
          '부족한 점을 찾아보기',
        ],
      },
    ],
  },
  beatmaking: {
    title: '미디작곡 커리큘럼',
    subtitle: '작곡 프로그램 이해와 샘플을 활용한 비트메이킹, 플러그인 사운드 디자인 (8주 / 4주당 30만원)',
    weeks: [
      {
        week: 1,
        items: [
          '만들고 싶은 장르 들어보고 분석하기',
          '노래 진행간 곡의 구조, 악기, 코드 등을 파악',
        ],
      },
      {
        week: 2,
        items: [
          '드럼 시퀀싱',
          '킥, 스네어, 하이햇 등 적절한 샘플 선택 후 리듬 만들기',
        ],
      },
      {
        week: 3,
        items: [
          '메인 테마 만들기',
          '가상악기, 샘플을 사용하여 직접 라인 만들기',
          '어울리는 샘플 적용해보기',
        ],
      },
      {
        week: 4,
        items: [
          '악기 레이어 및 사운드 디자인',
          '곡을 풍성하게 만드는 레이어 및 곡의 개성 살려주기',
        ],
      },
      {
        week: 5,
        items: [
          '완성된 8마디를 바탕으로 트랙메이킹',
          '인트로-벌스-브릿지-훅으로 이어지는 곡의 전개 만들기',
        ],
      },
      {
        week: 6,
        items: [
          '오토메이션으로 곡의 극적인 연출을 더하기',
          '볼륨뿐만 아니라 공간감, 악기의 질감을 구간마다 다르게 적용',
        ],
      },
      {
        week: 7,
        items: [
          '곡 정리하기',
          '음향적으로 부딪히는 부분을 정리하고 상업 음원에 준하는 볼륨 키우기',
        ],
      },
      {
        week: 8,
        items: [
          '작곡 속도에 불 붙이기',
          '지금까지 배운 방법을 바탕으로 곡을 빠르게 스케치하고 구성해보기',
        ],
      },
    ],
  },
  mixing: {
    title: '믹싱 & 마스터링 커리큘럼',
    subtitle: '4주당 30만원',
    weeks: [
      {
        week: 1,
        items: [
          'EQ에 대한 전반적인 사용법 및 활용방법',
          'Cut, Bell, Shelf 등의 모양 및 레조넌스 설정',
        ],
      },
      {
        week: 2,
        items: [
          'Compressor의 사용법 및 다이나믹 계열의 종류',
          'Gate, Limiter, Compressor 등의 사용방법과 Threshold, Ratio 등의 사용법',
        ],
      },
      {
        week: 3,
        items: [
          'Reverb, Delay 등 공간계열의 사용법 및 활용방법',
          'Send를 이용한 라우팅, 다양한 효과 만들기',
        ],
      },
      {
        week: 4,
        items: [
          'EQ를 이용한 오토메이션 사용 및 곡의 전체적인 사운드 정리',
          '마스터링의 기본 지식',
          '본인의 곡 혹은 STEM을 사용하여 믹싱 진행하기',
        ],
      },
    ],
  },
  djing: {
    title: '디제잉 커리큘럼',
    subtitle: '별도 문의',
    weeks: [
      {
        week: 1,
        items: [
          '디제잉에 대한 이해',
          'DJING 기초이론 / 장비 이해',
          '비트매칭 개념과 Sample 비트매칭',
          '선곡을 통한 비트 매칭',
        ],
      },
      {
        week: 2,
        items: [
          '믹싱',
          'Volume Fader Mixing',
          'EQing Mixing — 2band (HI / LOW), 3band (HI / MID / LOW)',
        ],
      },
      {
        week: 3,
        items: [
          '선곡',
          '조화로운 믹싱을 위한 선곡 방법',
        ],
      },
      {
        week: 4,
        items: [
          'Effect',
          'Sound Color fx / Beat Effect',
          'Effect의 효과적인 활용',
        ],
      },
      {
        week: 5,
        items: [
          '믹스셋 녹음',
          '30Min Mixset Recording',
        ],
      },
    ],
  },
};

export default function CurriculumSection() {
  const sectionRef = useRef<HTMLDivElement>(null);
  const [inView, setInView] = useState(false);
  const [activeTab, setActiveTab] = useState('lyrics');

  useEffect(() => {
    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) {
          setInView(true);
          observer.disconnect();
        }
      },
      { threshold: 0.1 }
    );
    if (sectionRef.current) observer.observe(sectionRef.current);
    return () => observer.disconnect();
  }, []);

  const data = curriculumData[activeTab];

  return (
    <section
      id="curriculum"
      ref={sectionRef}
      className="bg-studio-black py-24 md:py-32 px-6 md:px-12 lg:px-16"
    >
      <div className="w-full max-w-5xl mx-auto">
        {/* Section header */}
        <div
          className={`text-center mb-16 transition-all duration-700 ${
            inView ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-10'
          }`}
        >
          <span className="text-studio-gray/30 font-bebas text-[clamp(60px,10vw,140px)] leading-none block">
            04
          </span>
          <h2
            className="text-white font-bebas uppercase leading-none -mt-6 md:-mt-12"
            style={{ fontSize: 'clamp(40px, 6vw, 80px)', lineHeight: 1 }}
          >
            커리큘럼
          </h2>
          <p className="text-studio-gray font-sans text-lg md:text-xl mt-4">
            단계별 체계적인 학습 프로그램
          </p>
        </div>

        {/* Tabs */}
        <div
          className={`mb-10 transition-all duration-700 delay-100 ${
            inView ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-10'
          }`}
        >
          <div className="flex flex-wrap gap-2 justify-center">
            {tabs.map((tab) => (
              <button
                key={tab.key}
                type="button"
                onClick={() => setActiveTab(tab.key)}
                className={`px-4 py-2.5 rounded-full font-sans text-sm font-medium transition-all cursor-pointer whitespace-nowrap border ${
                  activeTab === tab.key
                    ? 'bg-studio-gold text-studio-black border-studio-gold'
                    : 'bg-studio-card text-studio-silver border-studio-border hover:border-studio-gold/50'
                }`}
              >
                {tab.label}
              </button>
            ))}
          </div>
        </div>

        {/* Curriculum content */}
        <div
          className={`transition-all duration-500 ${
            inView ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-10'
          }`}
        >
          <div className="bg-studio-card border border-studio-border rounded-lg p-8 md:p-10 mb-8">
            <div className="flex flex-col sm:flex-row sm:items-center sm:justify-between gap-3 mb-2">
              <h3 className="text-white font-bebas text-2xl md:text-3xl uppercase tracking-wide">
                {data.title}
              </h3>
              <span className="text-studio-gold font-bebas text-xl">
                {tabs.find((t) => t.key === activeTab)?.price}
              </span>
            </div>
            <p className="text-studio-gray font-sans text-sm">{data.subtitle}</p>
          </div>

          <div className="space-y-4">
            {data.weeks.map((week) => (
              <div
                key={week.week}
                className="bg-studio-card border border-studio-border rounded-lg overflow-hidden"
              >
                <div className="flex items-center gap-4 p-5 md:p-6 border-b border-studio-border">
                  <div className="w-10 h-10 flex items-center justify-center bg-studio-gold/10 rounded-full flex-shrink-0">
                    <span className="text-studio-gold font-bebas text-lg">
                      {week.week}
                    </span>
                  </div>
                  <p className="text-white font-bebas text-lg md:text-xl uppercase tracking-wide">
                    {week.week}주차
                  </p>
                </div>
                <div className="p-5 md:p-6 space-y-2">
                  {week.items.map((item, idx) => (
                    <div key={idx} className="flex items-start gap-3">
                      <div className="w-1.5 h-1.5 bg-studio-gold rounded-full flex-shrink-0 mt-2" />
                      <p className="text-studio-silver font-sans text-sm md:text-base leading-relaxed">
                        {item}
                      </p>
                    </div>
                  ))}
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}